<template>
  <div class="relative flex flex-col grow overflow-hidden">
    <div class="flex border-b bg-gray-50 shrink grow-0">
      <tx-input
        v-model="filter" rounded faicon="fa-light fa-magnifying-glass" clearable :placeholder="t('general.typeToFilter')"
        class="my-4 mx-2"
      />
      <tx-button
        v-tooltip="t('general.refresh')" width="24px"
        height="24px" icon-size="15px" class="my-6 mr-2" type="icon" faicon="fa-light fa-refresh" @click="onRefreshTree"
      />
    </div>
    <loader v-if="loading" />
    <div v-else class="overflow-y-auto">
      <tx-tree ref="tree" class="tree" :data="getCurrentTree" :filter="filter" @node-click="onTreeItemClick" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import TxInput from '@/shared/components/TxInput.vue'
import TxButton from '@/shared/components/TxButton.vue'
import TxTree from '@/shared/components/TxTree.vue'
import Loader from '@/shared/components/Loader.vue'
import { useUserStore } from '@/store/userData'

const emit = defineEmits<{
  (e: 'treeItemClick', evt?: ITreeNode)
}>()

const { t } = useI18n()
const userStore = useUserStore()

const loading = ref(false)
const filter = ref('')
const tree = ref<InstanceType<typeof TxTree>>()

const getCurrentTree = computed(() => userStore.currentTree || [])

async function onRefreshTree() {
  if (userStore.activeCatalog && userStore.activeCatalog.TreeDefinitions?.length) {
    const customerId = userStore.currentCustomer?.CustomerId || 0
    loading.value = true
    userStore.doLoadTree(userStore.activeCatalog.TreeDefinitions[0].Id, customerId)
      .finally(() => {
        loading.value = false
      })
  }
}

async function onTreeItemClick(e?: ITreeNode) {
  emit('treeItemClick', e)
}

defineExpose({
  tree,
})
</script>
